/**
 * Veeam Service Provider Console REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of rules that determine how specified values are compared with resource property values.
 */
export enum Collation {
    Ordinal = 'ordinal',
    Ignorecase = 'ignorecase',
    Lexicographic = 'lexicographic'
};

